// extracted by mini-css-extract-plugin
export default {"container":"TechnologiaDetails_container__3qvqQ","stage":"TechnologiaDetails_stage__bOHsm","btn_zamknij":"TechnologiaDetails_btn_zamknij__9dIbU"};